module.exports = __webpack_public_path__ + "img/RB-Leipzig.dcd6b376.png";